import React, { useState } from "react";
import { Button } from "react-bootstrap";
import Select2V2 from "@components/FormsV2/Select2/Select2V2";
import { ResolvedIntegration } from "../types/PsaProject";
import useStyles from "../styles/useStyles";

interface Props {
  integrations: ResolvedIntegration[];
  onSelect: (integration: ResolvedIntegration) => void;
}

const IntegrationPicker: React.FC<Props> = ({ integrations, onSelect }) => {
  const styles = useStyles();
  const [chosenId, setChosenId] = useState<string | null>(null);
  const options = integrations.map((i) => ({ value: i.id, label: i.label }));

  const handleContinue = () => {
    const chosen = integrations.find((i) => i.id === chosenId);
    if (chosen) onSelect(chosen);
  };

  return (
    <div className={styles.page} style={{ padding: 20 }}>
      <Select2V2
        label="Which PSA integration would you like to use?"
        value={options.find((o) => o.value === chosenId) ?? null}
        options={options}
        onChange={(e: any) => setChosenId(e?.value ?? null)}
      />
      <Button className="squareGreenButton" onClick={handleContinue}>
        Continue
      </Button>
    </div>
  );
};

export default IntegrationPicker;
